import React from 'react'
import {IconsGallery} from '../../pages/Gallery/IconsGallery';


export default function Gallery(props) {
  return (
    <>
      <IconsGallery
        canUpload={false}
        canEdit={false}
        canDelete={false}
        onClick={props.onClick}
        itemsPerPage={12}
      />
    </>
  )
}
